var _linearGradient, _path, _linearGradient2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingPatterns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_0df0e02aa9f4995ac352b685bd7f3d9a5fb1d30e256628a49a4f81d51e6c2d70",
    gradientUnits: "userSpaceOnUse",
    x1: 1279.48,
    y1: -483.626,
    x2: 1280.48,
    y2: -483.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M64.693 59.542l4.277 4.546 8.135-10.397M64.693 87.53l4.277 4.545 8.135-10.397M119.661 87.53l4.277 4.545 8.134-10.397M92.055 59.542l4.277 4.546 8.134-10.397"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_0df0e02aa9f4995ac352b685bd7f3d9a5fb1d30e256628a49a4f81d51e6c2d70",
    gradientUnits: "userSpaceOnUse",
    x1: 41.691,
    y1: 72.092,
    x2: 155.818,
    y2: 72.092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_0df0e02aa9f4995ac352b685bd7f3d9a5fb1d30e256628a49a4f81d51e6c2d70)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M154.548 113.669H42.941V30.515h111.627v83.055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M57.866 72.713h82.024M85.205 46.041v53.625M112.689 46.041v53.969M140.134 99.989H57.452V45.1h82.791v54.686M131.794 54.752L121.656 64.89M121.493 54.752l10.138 10.138M103.822 81.983L93.683 92.122M93.52 81.983l10.139 10.139"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingPatterns);
export default __webpack_public_path__ + "static/media/workingPatterns.10df9f8bd36e2db646ef4e6b092ed891.svg";
export { ForwardRef as ReactComponent };